import React, { useState, useEffect } from "react";
import Stylecontent from "./doctors.module.css";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import doctors from "./doctors";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { IoIosArrowDown } from "react-icons/io";
import { motion } from "framer-motion";
import DoctorCover from "../../Ui/doctors_bgimage.jpg";
import Cover from "../cover";
import DoctorCover1 from "../../Ui/doctors_bgimage1.jpg";
import DoctorCover2 from "../../Ui/doctors_bgimage2.jpg";
import { IoLogoWhatsapp } from "react-icons/io5";
import { IoShareSocial } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const Doctors = () => {
  const [doctorData, setdoctorData] = useState([]);

  useEffect(() => {
    const fetchdoctorData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "Appointments"));
        const data = [];
        querySnapshot.forEach((doc) => {
          data.push({ id: doc.id, ...doc.data() });
        });
        setdoctorData(data);
      } catch (error) {
        console.error("Error fetching Appointment data: ", error);
      }
    };

    fetchdoctorData();
  }, []);

  const navigate = useNavigate();

  const handleDoctorClick = (id) => {
    navigate(`/doctors/${id}`);
  };

  return (
    <>
      <Cover
        images={[DoctorCover, DoctorCover1, DoctorCover2]}
        heading="Welcome To Our Doctors"
        subHeading="Extraordinary Care For Your Health"
      />

      {/* <div id="doctors">
        <motion.div
          className={Stylecontent.toptext}
          initial={{ y: -100 }}
          animate={{ y: [200, 0] }}
          transition={{ duration: "1", delay: "1" }}
          whileInView="visible"
        >
          <h1>Meet Our Doctors Team</h1>
          <h3>To Find Best Doctors</h3>
          <p>
            Great doctor if you need your family member to get immediate
            assistance, emergency treatment or a simple consultation.
          </p>
        </motion.div>

        <div className={Stylecontent.container}>
          {doctors.map((i) => (
            <motion.div
              className={Stylecontent.cards}
              variants={fadeInAnimationVariants}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
            >
              <Card sx={{ maxWidth: 300, margin: 5 }}>
                <div className={Stylecontent.media}>
                  <CardMedia
                    sx={{ height: 200 }}
                    image={i.imageUrl}
                    title="Doctors"
                    style={{ objectFit: "cover", marginBottom: "0" }}
                  />
                </div>

                <motion.div
                  whileHover={{ background: "lightBlue", color: "black" }}
                >
                  <CardContent sx={{ padding: "16px" }}>
                    <Typography gutterBottom variant="h5" component="div">
                      {i.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {i.degree}
                    </Typography>
                  </CardContent>

                  <CardActions>
                    <div className={Stylecontent.btns}>
                      <Button variant="outlined" href="#outlined-buttons">
                        Share
                      </Button>
                    </div>
                    <div>
                      <Link
                        to={`/doctor/${i.id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <Button variant="outlined" href="#outlined-buttons">
                          View more
                        </Button>
                      </Link>
                    </div>
                  </CardActions>
                </motion.div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div> */}

      <div className={Stylecontent.maincontainer}>
        <motion.div
          className={Stylecontent.toptext}
          initial={{ y: -100 }}
          animate={{ y: [200, 0] }}
          transition={{ duration: "1", delay: "1" }}
          whileInView="visible"
        >
          <h1>Meet Our Doctors Panel</h1>
          <p>
            Great doctor if you need your family member to get immediate
            assistance, emergency treatment or a simple consultation.
          </p>
        </motion.div>

        <motion.div
          className={Stylecontent.arrowdown}
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 1 }}
        >
          <IoIosArrowDown size={40} color="#333" />
        </motion.div>

        <div className={Stylecontent.container}>
          {doctors.map((i) => (
            <motion.div
            key={i.id}
              className={Stylecontent.cards}
              initial={{ opacity: 0, scale: 0.8, y: 50 }}
              whileInView={{ opacity: 1, scale: 1, y: 0 }}
              whileHover={{ scale: 1.05 }}
              transition={{
                duration: 0.8,
                ease: "easeOut",
                type: "spring",

                delay: i.id * 0.1, // slight stagger if looping
              }}
            >
              <Card sx={{ borderRadius: 3, boxShadow: 4 }}>
                <div className={Stylecontent.media}>
                  <CardMedia
                    sx={{ height: 200 }}
                    image={i.imageUrl}
                    title="Doctors"
                    style={{ objectFit: "cover", marginBottom: "0" }}
                  />
                </div>

                <div className={Stylecontent.cardtext}>
                  <CardContent>
                    <Typography variant="h6" component="div" fontWeight="bold">
                      {i.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={1}>
                      {i.degree}
                    </Typography>

                    <div className={Stylecontent.badges}>
                      {i.specialities.slice(0, 2).map((spec, index) => (
                        <span key={index} className={Stylecontent.badge}>
                          {spec}
                        </span>
                      ))}
                    </div>

                    <Typography variant="caption" color="text.secondary" mt={1}>
                      {i.experience.slice(0, 60)}...
                    </Typography>
                  </CardContent>

                  <CardActions className={Stylecontent.actions}>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <IoLogoWhatsapp size={24} color="green" />
                      <IoShareSocial size={24} />
                    </div>

                    <Button
                      onClick={() => handleDoctorClick(i.id)}
                      variant="outlined"
                    >
                      View more
                    </Button>

                    {/* <Link
                      to={`/doctors/${i.id}`}
                      onClick={() => handleDoctorClick(doc.id)}
                      style={{ textDecoration: "none" }}
                    >
                      <Button variant="outlined">View more</Button>
                    </Link> */}
                  </CardActions>
                </div>
              </Card>
            </motion.div>
          ))}
        </div>

        {/* <div className={Stylecontent.container}>
                  {doctors.slice(0, 3).map((i) => (
                    <motion.div
                      className={Stylehome.cards}
                      initial={{ opacity: 0, scale: 0.8, y: 50 }}
              whileInView={{ opacity: 1, scale: 1, y: 0 }}
              whileHover={{ scale: 1.05 }}
              transition={{
                duration: 0.8,
                ease: "easeOut",
                type: "spring",

                delay: i.id * 0.1, // slight stagger if looping
              }}
                    >
                      <Card sx={{ maxWidth: 350, borderRadius: 3, boxShadow: 4 }}>
                        <div className={Stylehome.media}>
                          <CardMedia
                            sx={{ height: 200 }}
                            image={i.imageUrl}
                            title="Doctors"
                            style={{ objectFit: "cover", marginBottom: "0" }}
                            
                          />
                        </div>
        
                        <div
              className={Stylecontent.cardtext}
                        >
                          <CardContent sx={{ padding: "16px" , height: "20vh" }}>
                            <Typography gutterBottom variant="h5" component="div">
                              {i.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {i.degree}
                            </Typography>
                          </CardContent>
        
                          <CardActions>
                            <Button variant="outlined" href="#outlined-buttons">
                      Share
                    </Button>
                    <Link
                      to={`/doctor/${i.id}`}
                      style={{ textDecoration: "none" }}
                    >
                      <Button variant="outlined" href="#outlined-buttons">
                        View more
                      </Button>
                    </Link>
                          </CardActions>
                        </div>
                      </Card>
                    </motion.div>
                  ))}
                </div> */}
      </div>
    </>
  );
};

export default Doctors;
